// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"562ee8df","239":"c637a6ee","453":"1b7a9156","455":"3c1c2a83"}[chunkId] + ".chunk.js";
};